// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1PTSu","checkboxCol":"Table_checkboxCol__29oNw","emailCol":"Table_emailCol__3dSqn","actionCol":"Table_actionCol__7oSuJ"};